import { AxiosRequestConfig } from "axios";
import { GenericService } from "./Generic.service";

class OrpenService extends GenericService<any> {
  constructor() {
    super();
    this.setUri("Orpen");
  }

  public async getConfiguracao(empresaId: string) {
    return await super.getByResource(`Configuracao/${empresaId}`);
  }

  public async upsertConfiguracao(data: any) {
    return await super.postByResource(data, "Configuracao");
  }

  public async getTemplates(orpenConfiguracaoId: string) {
    return await super.getByResource(`Templates/${orpenConfiguracaoId}`);
  }

  public async saveTemplate(data: any) {
    return await super.postByResource(data, "Template");
  }

  public async deleteTemplate(id: string) {
    return await super.deleteByResource(null, `Template/${id}`);
  }

  public async getLogs(empresaId: string, page: number = 1, pageSize: number = 10, search?: string) {
    let url = `Logs/${empresaId}?page=${page}&pageSize=${pageSize}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return await super.getByResource(url);
  }

  public async getPreview(empresaId: string) {
    return await super.getByResource(`Preview/${empresaId}`);
  }

  public async processar(empresaId?: string) {
    const resource = empresaId ? `Processar/${empresaId}` : "Processar";
    return await super.postByResource({}, resource);
  }
}

export default new OrpenService();
